import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { subscriptionsCrudStateConfig } from "seneca-common/features/subscriptions/state/consts";

const subscriptionsMetaReducer = makeCrudStateReducer(
  subscriptionsCrudStateConfig
);
export default subscriptionsMetaReducer;
